<template>
  <div>
    <div>
      <div class="grid grid-cols-6 gap-6">
        <div
          class="col-span-6 border-gray-200 lg:pr-6 lg:border-r lg:col-span-2"
        >
          <form v-on:submit.prevent="onSubmit">
            <div class="flex justify-between">
              <h3 class="text-lg font-medium leading-6 text-gray-900">
                Ordine dalla camera
              </h3>
              <span
                @click="toogle()"
                :class="this.form.enable ? 'bg-indigo-600' : 'bg-gray-200'"
                role="checkbox"
                tabindex="0"
                aria-checked="false"
                class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline"
              >
                <!-- On: "translate-x-5", Off: "translate-x-0" -->
                <span
                  aria-hidden="true"
                  :class="this.form.enable ? 'translate-x-5' : 'translate-x-0'"
                  class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"
                ></span>
              </span>
            </div>
            <p class="w-64 max-w-full mt-1 text-sm leading-5 text-gray-500">
              Abilitando questa funzione i clienti potranno specificare il
              numero della camera. Troverai la lista degli ordini nell'apposita
              sezione
            </p>
          </form>
        </div>

        <div class="col-span-6 lg:col-span-4">
          <div class="flex flex-col">
            <div
              class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
            >
              <div
                class="inline-block min-w-full p-4 overflow-hidden align-middle border-b shadow sm:rounded-lg"
              >
                <form v-if="form.enable" v-on:submit.prevent="onSubmit">
                  <h3 class="text-base font-medium leading-6 text-gray-900 ">
                    Come vuoi ricevere gli ordini?
                  </h3>

                  <div>
                    <select
                      v-model="form.settings.selectedSource"
                      class="block w-full py-2 pl-3 pr-10 mt-1 text-base leading-6 border-gray-300 form-select focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    >
                      <option
                        v-for="source in sources"
                        v-bind:value="source.value"
                        :key="source.value"
                      >
                        {{ source.label }}
                      </option>
                    </select>
                  </div>

                  <div v-if="form.settings.selectedSource == 'whatsapp'">
                    <p class="mt-3 text-sm text-gray-700">
                      I clienti, una volta selezionati i piatti dal menu
                      digitale, potranno inviarti l'ordine attraverso un
                      messaggio WhatsApp che conterrà tutti i dettagli (piatti,
                      orario). Con questa modalità potrai rispondere al
                      messaggio confermando/rifiutando l'ordine comodamente dal
                      tuo cellulare.
                    </p>
                    <label
                      for="whatsapp"
                      class="block mt-2 text-sm font-medium leading-5 text-gray-700"
                      >Inserisci il numero WhatsApp*</label
                    >
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <div
                        class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                      >
                        <svg
                          class="w-5 h-5 text-gray-400"
                          fill="currentColor"
                          height="512"
                          viewBox="0 0 24 24"
                          width="512"
                        >
                          <path
                            d="M17.507 14.307l-.009.075c-2.199-1.096-2.429-1.242-2.713-.816-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.293-.506.32-.578.878-1.634.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.576-.05-.997-.042-1.368.344-1.614 1.774-1.207 3.604.174 5.55 2.714 3.552 4.16 4.206 6.804 5.114.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z"
                          />
                          <path
                            d="M20.52 3.449C12.831-3.984.106 1.407.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652c7.905 4.27 17.661-1.4 17.665-10.449 0-3.176-1.24-6.165-3.495-8.411zm1.482 8.417c-.006 7.633-8.385 12.4-15.012 8.504l-.36-.214-3.75.975 1.005-3.645-.239-.375c-4.124-6.565.614-15.145 8.426-15.145a9.865 9.865 0 017.021 2.91 9.788 9.788 0 012.909 6.99z"
                          />
                        </svg>
                      </div>
                      <input
                        :class="
                          formErrors['settings.whatsapp']
                            ? 'border-red-300'
                            : ''
                        "
                        v-model="form.settings.whatsapp"
                        name="whatsapp"
                        id="whatsapp"
                        class="block w-full pl-10 form-input sm:text-sm sm:leading-5"
                        placeholder="+39 00000000"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors['settings.whatsapp']"
                    >
                      {{ formErrors["settings.whatsapp"][0] }}
                    </p>
                  </div>

                  <div v-if="form.settings.selectedSource == 'menubyte'">
                    <p class="mt-3 text-sm text-gray-700">
                      I clienti, una volta selezionati i piatti dal menu
                      digitale, potranno inviarti l'ordine direttamente in
                      menuByte. Riceverai una email per segnalarti l'arrivo di
                      una nuova ordinazione, che potrai gestire nella sezione
                      "Ordini" (confermandola o rifiutandola) oppure contattando
                      direttamente il cliente per accordare un nuovo orario.
                    </p>
                    <label
                      for="whatsapp"
                      class="block mt-2 text-sm font-medium leading-5 text-gray-700"
                      >Inserisci l'email sulla quale ricevere le
                      notifiche*</label
                    >
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <div
                        class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                      >
                        <svg
                          class="w-5 h-5 text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884zM18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <input
                        :class="
                          formErrors['settings.email'] ? 'border-red-300' : ''
                        "
                        v-model="form.settings.email"
                        name="email"
                        id="email"
                        class="block w-full pl-10 form-input sm:text-sm sm:leading-5"
                        placeholder="email@miolocale.xyz"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors['settings.email']"
                    >
                      {{ formErrors["settings.email"][0] }}
                    </p>
                  </div>

                  <h3
                    class="mt-4 text-base font-medium leading-6 text-gray-900 "
                  >
                    Password
                    <span class="text-sm font-normal">(facoltativa)</span>
                  </h3>
                  <p class="mt-1 text-sm text-gray-700">
                    Puoi proteggere le ordinazioni impostando una password che
                    verrà chiesta al cliente al momento dell'invio dell'ordine.
                    E' consigliabile aggiornarla frequentemente.
                  </p>

                  <div>
                    <input
                      :class="
                        formErrors['settings.password'] ? 'border-red-300' : ''
                      "
                      v-model="form.settings.password"
                      class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
                    />
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors['settings.password']"
                    >
                      {{ formErrors["settings.password"][0] }}
                    </p>
                  </div>

                  <h3
                    class="mt-4 text-base font-medium leading-6 text-gray-900"
                  >
                    Permetti ai clienti di scegliere una data di consegna
                    differente da quella odierna
                  </h3>

                  <div>
                    <select
                      v-model="form.settings.selectedOrderToday"
                      class="block w-full py-2 pl-3 pr-10 mt-1 text-base leading-6 border-gray-300 form-select focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    >
                      <option value="yes">
                        Si
                      </option>
                      <option value="no">
                        No
                      </option>
                    </select>
                  </div>

                  <h3
                    class="mt-4 text-base font-medium leading-6 text-gray-900"
                  >
                    Permetti ai clienti di scegliere l'ora indicativa di
                    consegna dell'ordine
                  </h3>

                  <div>
                    <select
                      v-model="form.settings.selectedOrderHour"
                      class="block w-full py-2 pl-3 pr-10 mt-1 text-base leading-6 border-gray-300 form-select focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    >
                      <option value="yes">
                        Si
                      </option>
                      <option value="no">
                        No
                      </option>
                    </select>
                  </div>

                  <h3
                    class="mt-4 text-base font-medium leading-6 text-gray-900"
                  >
                    Note per i clienti
                  </h3>

                  <div>
                    <textarea
                      :class="
                        formErrors['settings.notes'] ? 'border-red-300' : ''
                      "
                      v-model="form.settings.notes"
                      placeholder="Inserisci qui le informazioni da comunicare ai clienti per esempio le fasce orarie in cui è disponibile il servizio in camera"
                      class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
                    ></textarea>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors['settings.notes']"
                    >
                      {{ formErrors["settings.notes"][0] }}
                    </p>
                  </div>
                  <button
                    type="submit"
                    class="inline-flex justify-center px-4 py-2 mt-4 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                  >
                    Salva
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderSettings from "../apis/OrderSettings";

export default {
  data() {
    return {
      id: this.$route.params.id,
      tl: {},
      formErrors: {},
      form: {
        enable: false,
        settings: {
          selectedSource: "whatsapp",
          notes: "",
          password: "",
          whatsapp: "",
          email: "",
        },
      },
      sources: [
        {
          label: "WhatsApp",
          value: "whatsapp",
        },
        {
          label: "menuByte",
          value: "menubyte",
        },
      ],
    };
  },
  mounted() {
    OrderSettings.getRoomServiceSettings(this.id).then((response) => {
      this.form = response.data;
    });
  },
  created() {},
  methods: {
    toogle() {
      this.form.enable = !this.form.enable;
      this.onSubmit();
    },

    onSubmit: function() {
      this.formErrors = {};
      this.$store.dispatch("updateSpinner", true);

      OrderSettings.updateRoomServiceSettings(this.id, this.form)
        .then(() => {
          this.$store.dispatch("updateSpinner", false);
          this.$store.dispatch("addNotification", {
            id: Math.floor(Math.random() * 100000),
            title: "Dati aggiornati",
            description: "",
          });
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
            this.$store.dispatch("addNotification", {
              id: Math.floor(Math.random() * 100000),
              title: "Correggi gli errori",
              description: "",
              succes: false,
            });
          }
          this.$store.dispatch("updateSpinner", false);
        });
    },
  },
};
</script>
